import React, { createContext, useEffect } from 'react'

import { ConfigurationEntry } from 'live/lib/api'

import { CHANNELS_SETTINGS_URL } from 'plugin-channelmanager/utils/constants'

import { themeAwardWidgetDecorator } from '../utils'
import { ChannelsSettings } from './ChannelsSettings'

interface ILivePageProps {
    extra: {
        hideHeader: boolean
        hideFooter: boolean
    }
    id: IQueryParamsList | IQueryParamsEdit
    urlParams: (string | Record<string, string | number>)[]
}

export interface IQueryParamsList {
    type: 'list'
    perPage?: number
    page?: number
    orderBy?: string
    direction?: 'ASC' | 'DESC'
    filterBy?: number
    keyword?: string
    [x: string]: string | number
}

export interface IQueryParamsEdit {
    type: 'edit'
    id?: number
}

export interface IChannelsSettingsRouteContext<P extends IQueryParamsList | IQueryParamsEdit> {
    params: P
    setParams: (newParams: IQueryParamsList | IQueryParamsEdit) => void
}

const defaultParams: IQueryParamsList | IQueryParamsEdit = {
    type: 'list',
    page: 1,
    perPage: 50,
    direction: 'ASC',
    orderBy: 'ID'
}

function toQueryString(obj: IQueryParamsList | IQueryParamsEdit): string {
    const vet = ['string', 'number', 'boolean']
    const vet2 = ['undefined', 'null']

    return Object.keys(obj)
        .filter(key => vet.includes(typeof obj[key]))
        .map(key => (!vet2.includes(typeof obj[key]) ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}

export function setParams(params: IQueryParamsList | IQueryParamsEdit): void {
    window.location.href = `/#/config/${CHANNELS_SETTINGS_URL}?${toQueryString(params)}`
}

export const ChannelsSettingsRouteContext = createContext({
    params: defaultParams,
    setParams
} as IChannelsSettingsRouteContext<any>) // eslint-disable-line prettier/prettier, @typescript-eslint/no-explicit-any

const ChannelsSettingsWrapper: React.FC<ILivePageProps> = ({ id: params }) => {
    useEffect(() => {
        if (!params || !params.type || (params.type === 'edit' && !params.id)) {
            setParams({ ...defaultParams })
        } else {
            if (params.type === 'list') {
                setParams({ ...defaultParams, ...params })
            }
        }
    }, [params])

    return (
        <ChannelsSettingsRouteContext.Provider value={{ params: params ?? defaultParams, setParams }}>
            <ChannelsSettings />
        </ChannelsSettingsRouteContext.Provider>
    )
}

export default themeAwardWidgetDecorator(ChannelsSettingsWrapper, ':root')
